import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  Divider,
  Form,
  Row,
  Col,
  Space,
  Table,
  Upload,
  Alert,
  Tag,
} from "antd";
import {
  UploadOutlined,
  DeleteOutlined,
  EyeFilled,
  ExclamationCircleOutlined,
  DownloadOutlined,
} from "@ant-design/icons";

import "../../styles/seims.css";
import {openNotification, progressIndicatorEnum, docsEnum, FileCard, pdfjsVersion} from "@seims/shared";

import lookupApi from "../../services/candidateLookupService";
import api from "../../services/nysService";
import { Messages, Notify } from "../../services/custom/Messages";
import util from "../../utils/functions/custom";

import { Viewer, Worker } from "@react-pdf-viewer/core";

// Plugins
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

// Import styles
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { recordError } from "../../utils/logService";

const formItemLayout = {
  labelCol: {
    span: 12,
  },
  wrapperCol: {
    span: 18,
  },
};

const SupportingDocumentView = ({ onProgressUpdate, data, readOnly }) => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const [form] = Form.useForm();
  const formName = "SupportingDocsForm";
  const { confirm } = Modal;

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [selectedDocType, setSelectedDocType] = useState({});
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [toggleFiles, setToggleFiles] = useState(false);
  const [docTypes, setDocTypes] = useState([]);
  const [progress, setProgress] = useState(0);
  const [replaceDoc, setReplaceDoc] = useState(false);
  const [newDoc, setNewDoc] = useState({});
  const [formAttr, setFormAttr] = useState();

  const columns = [
    {
      title: "File Name",
      dataIndex: "fileName",
      key: "1",
    },
    {
      title: "Document Description",
      dataIndex: "typeDescription",
      key: "2",
    },
    {
      title: "Preview/Download",
      dataIndex: "preview",
      key: "5",
      render: (_, record) => {
        // if (record.id > 0) {
          return (
            <>
              <Space>
              <Button
                type="primary"
                icon={<EyeFilled />}
                onClick={() => PreviewDocument(record)}
              />
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                onClick={() => handleFileDownload(record)}
              />
              </Space>
            </>
          );
        // }
      },
    },
  ];

  useEffect(() => {
    getDocTypes();
  }, []);

  useEffect(() => {
    getDocuments();
  }, [data]);

  const getDocTypes = async () => {
    try {
      const response = await lookupApi.getDocTypes();

      if (response) {
        const { data } = response;
        const _data = data.map((c) => ({
          key: c.key,
          value: c.value,
          id: c.value.replaceAll(" ", "_").toString().trim(),
        }));

        setDocTypes(_data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getDocuments = () => {
    fileBuilder();
  };

  const fileBuilder = () => {
    let fileData = [{}];

    fileData = data.map((item) => ({
      fileName: item.filename,
      size: item.fileSize,
      type: item.contentType,
      documentType: item.documentType,
      typeDescription: item.documentType,
      uploadDate: item.lastModified,
      file: item.file === undefined ? {} : item.file,
      uuid: item.uuid,
      hasFile: false,
    }));

   
    setUploadedFiles(fileData);
  };

  const handleUpload = (doc) => {
    const fSize = doc.size / 1024 / 1024;

    if (fSize > 5) {
      openNotification("File Size", "Image must smaller than 5MB!", Notify.WARNING);
      return Upload.LIST_IGNORE;
    }

    setNewDoc(doc);
    const selectedDoc = uploadedFiles.filter(
      (c) => c.documentType === selectedDocType.key
    );

    if (selectedDoc.length > 0) {
      const fileName = selectedDoc[0].fileName;
      confirmDocReplacement(fileName);
    
      //? DO NOT UPLOAD DOC IF USER DOESN'T WANT TO REPLACE
      if (!replaceDoc) return Upload.LIST_IGNORE; 
      return;
    }

    //? ONLY ADD UNIQUE ITEMS BASED ON THE DOCUMENT TYPE
    setReplaceDoc(false);
    updateDocumentList(doc, false);
  };

  const PreviewDocument = async (record) => {
    const response = await api.getFileForHost(record.uuid);
    console.log("REUSLTS", response)
    if (response) {
      const { data } = response;
      const new_blob = new Blob([data]);

      const url = URL.createObjectURL(new_blob);

      setPreviewImage(url || record.preview);
      setPreviewOpen(true);
      setPreviewTitle(record.fileName);
      setToggleFiles(record.type != "application/pdf");
    }
  };
  const handleFileDownload = async (record) => {
    const response = await api.getFileForHost(record.uuid);

    if (response) {
      const { data } = response;
      const new_blob = new Blob([data]);

      const url = URL.createObjectURL(new_blob);
      const downloadLink = document.createElement("a");

      downloadLink.href = url;
      downloadLink.download = record.fileName;
      downloadLink.click();
      URL.revokeObjectURL(url);
    }
  };

  const updateDocumentList = (doc, replace) => {
    let fileData = [{}];
    var today = new Date();
    let _uploadedFiles = [];
    let _progress;

    fileData.fileName = doc.name;
    fileData.size = doc.size;
    fileData.type = doc.type;
    fileData.documentType = selectedDocType.key;
    fileData.typeDescription = selectedDocType.value;
    fileData.uploadDate = today.toLocaleDateString("en-US");
    fileData.file = doc;
    fileData.hasFile = true;

    if (replace) {
      let existingDoc = uploadedFiles.find(
        (c) => c.documentType === selectedDocType.key
      );
      fileData.id = existingDoc.id;

      const newFiles = uploadedFiles.filter(
        (c) => c.documentType !== selectedDocType.key
      );
      _uploadedFiles = [...newFiles, fileData];
    } else {
      //? THIS IS FOR THE DEFAULT DCOCUMENT THAT HAS NOT BEEN SAVED
      fileData.id = 0;
      _uploadedFiles = [...uploadedFiles, fileData];
    }

    _progress = (_uploadedFiles.length / 5) * 100;
    setUploadedFiles(_uploadedFiles);
    setProgress(_progress);
  };

  const uploadInfo = {
    accept: ".png, .pdf, .jpg, jpeg",
    multiple: false,
    showUploadList: { showRemoveIcon: false },
    beforeUpload: handleUpload,
  };

  const removeFile = (file) => {
    const { typeDescription } = file;

    if (file.id > 0) {
      const msg = util.parseMessage(Messages.FILE_ALREADY_SAVED, "NYS");
      openNotification("File Removal", msg, Notify.ERROR);
      return;
    }

    if (typeDescription === docsEnum.CURRICULUM_VITAE) {
      form.setFieldsValue({ "Curriculum Vitae (CV)": [] });
    } else if (typeDescription === docsEnum.QUALIFICATION) {
      form.setFieldsValue({ "Copy of Highest Qualification": [] });
    } else if (typeDescription === docsEnum.CERTIFIED_ID) {
      form.setFieldsValue({ "Certified ID Copy": [] });
    } else if (typeDescription === docsEnum.GRADE_12_CERT) {
      form.setFieldsValue({ "Grade 12 Certified Copy": [] });
    } else {
      form.setFieldsValue({ "Motivation Letter": [] });
    }

    const _uploadedFiles = [...uploadedFiles];
    const _progress = (_uploadedFiles.length / 5) * 100;

    setProgress(_progress);

    setUploadedFiles((current) =>
      current.filter((element) => {
        return element.fileName !== file.fileName;
      })
    );
  };

  const onFileSelection = (selectedDocType) => {
    setSelectedDocType(selectedDocType);
  };

  const handleCancel = () => setPreviewOpen(false);

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  const onFinishFailed = (values) => {
  }

  const onSubmit = async () => {
    try {
      var msg;
      if (uploadedFiles.length === 0) {
        msg = util.parseMessage(Messages.FILE_UPLOAD_NO_FILE, "NYS");
        openNotification("File upload", msg, Notify.ERROR);
        return;
      }
      
      const request = await api.addSuppDocuments(uploadedFiles);
      
      if (request.status == 200 || request.status == 201) {
        
        if (progress == 100) 
          onProgressUpdate(progressIndicatorEnum.COMPLETED, progress);
        else 
          onProgressUpdate(progressIndicatorEnum.IN_PROGRESS, progress);

        msg = util.parseMessage(Messages.ADD_SUCCESS, "Documents detail(s)");
        openNotification("File upload", msg, Notify.SUCCESS);
        
        form.resetFields();
        return;
      }
      
      msg = util.parseMessage(Messages.ADD_FAILURE, "Documents detail(s)");
      openNotification("File upload", msg, Notify.ERROR);
      
    } catch (error) {
      recordError(error);
      // console.log("DOCUMENTS FAILED TO SAVE", error);
      openNotification("File upload", msg, Notify.ERROR);
    }
  };

  const confirmDocReplacement = (docName) => {
    confirm({
      title: `Are you sure you want to replace document (${docName})?`,
      icon: <ExclamationCircleOutlined />,
      content: "Confirm replacement",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",

      onOk() {
        setReplaceDoc(true);
      },

      onCancel() {
        setReplaceDoc(false);
      },
    });
  };

  const title = "Supporting Documents";
  const subTitle = "Upload your documents (max 5MB for each file)";

  return (
    <>
      {/* <PageHeader
        title={title}
        subTitle={subTitle}
        className="ant-page-header-heading-sub-title"
      ></PageHeader>
      <Divider /> */}
      <h1 className="center-align">{title}</h1>
      <p className="sub-title center-align">{subTitle}</p>
      <br />
      
      <Row>
        <div key="grid__fileupload" className="grid__fileupload">
          <Table
            dataSource={uploadedFiles}
            columns={columns}
            bordered
            pagination={{ pageSize: 10 }}
            size="middle"
          />
        </div>
        <div key="card__fileupload" className="card__fileupload">
          {uploadedFiles.map((file, index) => (
            <FileCard
              key={index}
              onClick={() => removeFile(file)}
              onDownloadFile={() => handleFileDownload(file)}
              file={file}
              disabled={readOnly}
            />
          ))}
        </div>
      </Row>
      <Row>
        <Col xs={24}>
          {false && <Button
            className="right-align-button"
            key="2"
            htmlType="submit"
            form={formName}
            type="primary"
            shape="round"
            disabled={readOnly}
            style={{ marginLeft: "40px", marginTop: "20px" }}
          >
            Save Supporting Documents
          </Button>}
        </Col>
      </Row>
      <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
        width="50%"
        // bodyStyle={{ height: 700 }}
      >
        {toggleFiles ? (
          <img
            alt="example"
            style={{
              width: "100%",
            }}
            src={previewImage}
          />
        ) : (
          <Worker
            workerUrl={`https://unpkg.com/pdfjs-dist@${pdfjsVersion()}/build/pdf.worker.min.js`}
          >
            <Viewer
              fileUrl={previewImage}
              plugins={[defaultLayoutPluginInstance]}
              renderError={console.log}
            />
          </Worker>
        )}
      </Modal>
    </>
  );
};

export default SupportingDocumentView;